import React from 'react';
const ToneDashboard = React.lazy(() => import('./components/ToneDashboard/Dashboard'));
const DemoAdmin = React.lazy(() => import('./components/DemoAdminDashboard/Dashboard'));

// Components for nested routes
const ToneHomeDashboard = React.lazy(() => import('./components/ToneDashboard/Dashboard'));
const Location = React.lazy(() => import('./components/ToneDashboard/Location'));

const SuperAdminDashBoard = React.lazy(() => import('./components/SuperAdmin/Dashboard'));
const Companies = React.lazy(() => import('./components/SuperAdmin/Companies'));
const Tenants = React.lazy(() => import('./components/SuperAdmin/Tenants'));
const Hierarchy = React.lazy(() => import('./components/SuperAdmin/Hierarchy'));
const SuperAdminUsers = React.lazy(() => import('./components/SuperAdmin/Users'));
const SuperAdminRole = React.lazy(() => import('./components/SuperAdmin/Role'));
const SuperAdminPermissions = React.lazy(() => import('./components/SuperAdmin/Permissions'));
const ModulePermissions = React.lazy(() => import('./components/SuperAdmin/ModulePermissions'));
const ToneWeb = React.lazy(() => import('./components/DemoAdminDashboard/ToneWeb'));
const CampaignMedia = React.lazy(() => import('./components/DemoAdminDashboard/CampaignMedia'));
const DemoMedia = React.lazy(() => import('./components/DemoAdminDashboard/DemoMedia'));
const Action = React.lazy(() => import('./components/DemoAdminDashboard/Action'));
const UserAccessLayout = React.lazy(() => import('./components/includes/PrivateRoute'));
const Profile = React.lazy(() => import('./components/profile/Profile'));
const UserRequest = React.lazy(() => import('./components/ToneDashboard/UserRequest'));
const DeviceDetails = React.lazy(() => import('./components/ToneDashboard/DeviceDetails'));
const UserLogEvent = React.lazy(() => import('./components/userActivity/UserLogEvent'));
const UserSession = React.lazy(() => import('./components/profile/UserSession'));
const AESComponent = React.lazy(() => import('./components/Aes/Generate'));
export default [
  {
    path: '/tone-home-dashboard',
    component: ToneHomeDashboard,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-dashboard/locations',
    component: Location,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/dashboard',
    component: SuperAdminDashBoard,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/companies',
    component: Companies,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/tenants',
    component: Tenants,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/hierarchy',
    component: Hierarchy,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/users',
    component: SuperAdminUsers,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/roles',
    component: SuperAdminRole,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/permissions',
    component: SuperAdminPermissions,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-admin/module-permissions',
    component: ModulePermissions,
    layout: UserAccessLayout,
  },
  {
    path: '/demo-admin/clients',
    component: ToneWeb,
    layout: UserAccessLayout,
  },
  {
    path: '/demo-admin/client-dashboard',
    component: DemoAdmin,
    layout: UserAccessLayout,
  },
  {
    path: '/demo-admin/campaign-media',
    component: CampaignMedia,
    layout: UserAccessLayout,
  },
  {
    path: '/demo-admin/demo-media',
    component: DemoMedia,
    layout: UserAccessLayout,
  },
  {
    path: '/demo-admin/manage-actions',
    component: Action,
    layout: UserAccessLayout,
  },
  {
    path: '/profile/about',
    component: Profile,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-dashboard/user-request',
    component: UserRequest,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-dashboard/user-request/device-details',
    component: DeviceDetails,
    layout: UserAccessLayout,
  },
  {
    path: '/profile/user-activity',
    component: UserLogEvent,
    layout: UserAccessLayout,
  },
  {
    path: '/profile/user-sessions',
    component: UserSession,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-dashboard/home',
    component: ToneDashboard,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-dashboard',
    component: ToneDashboard,
    layout: UserAccessLayout,
  },
  {
    path: '/aes/generate',
    component: AESComponent,
    layout: UserAccessLayout,
  },
  {
    path: '/aes',
    component: AESComponent,
    layout: UserAccessLayout,
  },
  {
    path: '/tone-portal',
    component: ToneDashboard,
    layout: UserAccessLayout,
  },
  {
    path: '/profile',
    component: Profile,
    layout: UserAccessLayout,
  },
];
